<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="90%" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button v-if="showSubmitForApproval" type="primary" size="small" :disabled="approveDocActionLoading" @click="submitForApprovalFromView">提交审批</el-button>
            <el-button v-if="showWfApprove" type="primary" size="small" :disabled="approveDocActionLoading" @click="wfApproveFromView">审批通过</el-button>
            <el-button v-if="showWfReject" type="primary" size="small" :disabled="approveDocActionLoading" @click="wfRejectFromView">驳回</el-button>
            <el-button v-if="showApproveButton" type="primary" size="small" :disabled="approveDocActionLoading" @click="approveFromView">审核</el-button>
            <el-button v-if="showUnapprove" type="primary" size="small" :disabled="approveDocActionLoading" @click="unapproveFromView">弃审</el-button>
            <el-button
              v-if="isAuth('purchase:purchaseRequisition:convertPo') && dataForm.approveStatus === '2'"
              type="primary"
              size="small"
              @click="convertPoFromView"
            >转采购订单</el-button>
            <el-button v-if="showTrail" type="primary" size="small" @click="trailVisible = true">审批轨迹</el-button>
            <el-button v-if="isAuth('purchase:purchaseRequisition:update')" type="primary" size="small" :disabled="!canEditDoc || approveDocActionLoading" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('purchase:purchaseRequisition:delete')" type="primary" size="small" :disabled="!canEditDoc || approveDocActionLoading" @click="deleteFromView">删除</el-button>
          </el-button-group>
          <div v-if="workflowActionHint" class="wf-hint">{{ workflowActionHint }}</div>
        </div>
      </div>
    </template>

    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="90px">
      <el-row :gutter="12">
        <el-col :span="6">
          <el-form-item label="请购单号" prop="requisitionCode">
            <el-input v-model="dataForm.requisitionCode" :disabled="formReadonly || codeReadonly || !!dataForm.requisitionId" :placeholder="codeReadonly && !dataForm.requisitionId ? '保存时自动生成' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="请购日期" prop="requisitionDate">
            <el-date-picker v-model="dataForm.requisitionDate" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="请购部门">
            <el-input v-model="dataForm.deptName" disabled placeholder="当前账号未设置部门" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请人">
            <el-input v-model="dataForm.applicantName" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="6">
          <el-form-item label="需求日期">
            <el-date-picker
              v-model="defaultRequiredDate"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:100%"
              :disabled="formReadonly"
              placeholder="批量填充明细"
              @change="onDefaultRequiredDateChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="备注">
            <el-input v-model="dataForm.remark" :disabled="formReadonly" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-alert
        v-if="readonly && workflowActionHint"
        :title="workflowActionHint"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 12px"
      />

      <div v-if="!formReadonly" style="margin-bottom:10px;">
        <el-button type="primary" size="small" @click="materialSelectorVisible = true">选择物料</el-button>
      </div>

      <el-table border :data="dataForm.requisitionLines" :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="150" header-align="center" align="left" show-overflow-tooltip />
        <el-table-column prop="materialName" label="产品名称" min-width="180" header-align="center" align="left" show-overflow-tooltip />
        <el-table-column prop="specs" label="规格" min-width="120" header-align="center" align="left" show-overflow-tooltip />
        <el-table-column prop="quantity" label="请购数量" width="160" header-align="center" align="right">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.quantity"
              :disabled="formReadonly"
              :min="0"
              :precision="2"
              controls-position="right"
              style="width: 100%"
            />
          </template>
        </el-table-column>
        <el-table-column prop="requiredDate" label="需求日期" width="150" header-align="center" align="left">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.requiredDate" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formReadonly" />
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" :disabled="formReadonly" placeholder="备注" />
          </template>
        </el-table-column>
        <el-table-column v-if="formReadonly" prop="convertedQuantity" label="已转采购" width="100" header-align="center" align="right" />
        <el-table-column v-if="!formReadonly" label="操作" width="70" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeLine(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :disabled="submitLoading" @click="submitHandle">确定</el-button>
    </span>

    <material-selector :visible.sync="materialSelectorVisible" :multiple="true" @select-multiple="chooseMaterials" />
    <workflow-trail-dialog :visible.sync="trailVisible" :workflow-instance="dataForm.workflowInstance" :tasks="trailTasks" />
  </el-dialog>
</template>

<script>
import MaterialSelector from '../../components/MaterialSelector.vue'
import WorkflowTrailDialog from '../../components/WorkflowTrailDialog.vue'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import {
  canShowDirectApproveButton,
  isWorkflowEditable,
  normalizeWorkflowDocUi,
  shouldShowWorkflowTrail
} from '../../utils/workflow'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

function blankForm(id) {
  return {
    requisitionId: id || '',
    requisitionCode: '',
    requisitionDate: today(),
    deptId: '',
    deptName: '',
    applicantId: '',
    applicantName: '',
    approveStatus: '',
    workflowStatus: 'draft',
    workflowInstance: null,
    myPendingTask: null,
    workflowDocUi: null,
    createBy: '',
    remark: '',
    requisitionLines: []
  }
}

export default {
  components: { MaterialSelector, WorkflowTrailDialog },
  data() {
    return {
      visible: false,
      readonly: false,
      submitLoading: false,
      approveDocActionLoading: false,
      workflowDocUiReady: false,
      codeReadonly: false,
      materialSelectorVisible: false,
      trailVisible: false,
      defaultRequiredDate: '',
      permCodes: [],
      dataForm: blankForm(),
      dataRule: {
        requisitionCode: [{
          validator: (rule, value, callback) => {
            if (this.codeReadonly) {
              callback()
              return
            }
            if (!value || !String(value).trim()) {
              callback(new Error('请购单号不能为空'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        requisitionDate: [{ required: true, message: '请购日期不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    formReadonly() {
      return this.readonly || this.dataForm.approveStatus === '2' || !this.canEditDoc
    },
    canEditDoc() {
      return isWorkflowEditable(this.dataForm.workflowStatus, this.dataForm.approveStatus)
    },
    workflowUi() {
      return normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
    },
    hasRequisitionActPerm() {
      return this.isAuth('purchase:purchaseRequisition:save') || this.isAuth('purchase:purchaseRequisition:update')
    },
    isRequisitionCreator() {
      const uid = (this.$store.state.user || {}).id
      if (!uid) return false
      return String(this.dataForm.createBy || '') === String(uid)
    },
    showViewToolbar() {
      return this.readonly && !!this.dataForm.requisitionId
    },
    showSubmitForApproval() {
      const ui = this.workflowUi
      if (!this.showViewToolbar || !this.workflowDocUiReady || !ui || !ui.submitAllowed) return false
      if (!this.isRequisitionCreator) return false
      return this.isAuth('purchase:purchaseRequisition:submit') || this.hasRequisitionActPerm
    },
    showApproveButton() {
      if (!this.showViewToolbar || !this.workflowDocUiReady || String(this.dataForm.approveStatus) === '2') return false
      if (!canShowDirectApproveButton(this.dataForm.workflowDocUi)) return false
      if (this.isAuth('purchase:purchaseRequisition:approve')) return true
      return this.hasRequisitionActPerm
    },
    showUnapprove() {
      return this.showViewToolbar && this.isAuth('purchase:purchaseRequisition:unapprove') && String(this.dataForm.approveStatus) === '2'
    },
    showWfApprove() {
      return this.showViewToolbar
        && this.isAuth('workflow:task:approve')
        && this.dataForm.myPendingTask
        && this.dataForm.myPendingTask.taskId
    },
    showWfReject() {
      return this.showWfApprove && this.isAuth('workflow:task:reject')
    },
    showTrail() {
      return shouldShowWorkflowTrail({
        inViewMode: this.showViewToolbar,
        workflowInstance: this.dataForm.workflowInstance,
        workflowDocUi: this.workflowUi,
        workflowDocUiReady: this.workflowDocUiReady
      })
    },
    trailTasks() {
      const inst = this.dataForm.workflowInstance
      return (inst && inst.tasks) || []
    },
    isWorkflowSubmitter() {
      const uid = (this.$store.state.user || {}).id
      const inst = this.dataForm.workflowInstance
      if (!uid || !inst) return false
      return String(inst.submitBy || '') === String(uid)
    },
    workflowActionHint() {
      const ui = this.workflowUi
      if (!ui || !ui.workflowEnabled || String(this.dataForm.approveStatus) === '2') return ''
      if (ui.inApproval) {
        if (!this.dataForm.myPendingTask && this.isWorkflowSubmitter) {
          return '当前步骤需由其他审批人处理（不允许提交人自审），请等待待办人审批。'
        }
        return ''
      }
      if (ui.definitionMatched && ui.submitAllowed) return ''
      if (!ui.definitionMatched && ui.submitAllowed) {
        return '已启用多级审批，尚未配置审批流程。请点击「提交审批」查看配置指引。'
      }
      if (!ui.definitionMatched && ui.directApproveAllowed) {
        return '已启用多级审批，尚未配置匹配的审批流程，可直接审核或联系管理员配置流程。'
      }
      if (!ui.definitionMatched && !ui.directApproveAllowed && !ui.submitAllowed) {
        return '已启用多级审批，请先在「审批流程定义」中配置请购单流程后再提交。'
      }
      return ''
    },
    formRules() {
      return this.formReadonly ? {} : this.dataRule
    },
    dialogTitle() {
      if (this.readonly) return '查看请购单'
      return this.dataForm.requisitionId ? '修改请购单' : '新增请购单'
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.readonly = !!readonly
      this.workflowDocUiReady = false
      this.visible = true
      this.submitLoading = false
      this.approveDocActionLoading = false
      this.codeReadonly = !!id
      this.defaultRequiredDate = ''
      this.$nextTick(() => {
        this.dataForm = blankForm(id)
        this.$refs.dataForm && this.$refs.dataForm.clearValidate()
        if (!id) {
          this.resolveCode()
          this.applyLoginUserDefaults()
        }
        if (id) {
          request.get('/purchase/purchaseRequisition/info/' + id).then(res => {
            const body = res.data || {}
            this.mergeRequisitionBody(body)
          }).catch(() => {})
        }
      })
    },
    mergeRequisitionBody(b) {
      const lines = b.requisitionLines || b.lines || []
      this.dataForm = {
        ...blankForm(b.requisitionId),
        ...b,
        workflowDocUi: b.workflowDocUi || null,
        workflowInstance: b.workflowInstance || null,
        myPendingTask: b.myPendingTask || null,
        requisitionDate: (b.requisitionDate || '').slice(0, 10),
        requisitionLines: this.sortRequisitionLines(lines.map(line => ({
          ...line,
          quantity: Number(line.quantity),
          requiredDate: line.requiredDate ? String(line.requiredDate).slice(0, 10) : ''
        })))
      }
      if (normalizeWorkflowDocUi(b.workflowDocUi)) {
        this.workflowDocUiReady = true
      }
      this.initDefaultRequiredDateFromLines()
      this.$refs.dataForm && this.$refs.dataForm.clearValidate()
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'purchaseRequisition' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.requisitionCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('requisitionCode')
        })
      }).catch(() => {})
    },
    applyLoginUserDefaults() {
      const storeUser = this.$store.state.user || {}
      if (storeUser.id) {
        this.dataForm.applicantId = storeUser.id
        this.dataForm.applicantName = storeUser.nickname || storeUser.nickName || storeUser.name || storeUser.username || ''
        this.dataForm.deptId = storeUser.deptId || ''
        this.dataForm.deptName = storeUser.deptName || ''
      }
      request.get('/auth/me').then(res => {
        const u = res.data || {}
        this.dataForm.applicantId = u.id || this.dataForm.applicantId
        this.dataForm.applicantName = u.nickname || u.username || this.dataForm.applicantName
        this.dataForm.deptId = u.deptId || u.departId || ''
        this.dataForm.deptName = u.deptName || u.departName || ''
      }).catch(() => {})
    },
    initDefaultRequiredDateFromLines() {
      const lines = this.dataForm.requisitionLines || []
      const dates = lines.map(l => (l.requiredDate ? String(l.requiredDate).slice(0, 10) : '')).filter(Boolean)
      const uniq = [...new Set(dates)]
      if (uniq.length === 1) this.defaultRequiredDate = uniq[0]
    },
    onDefaultRequiredDateChange(val) {
      if (!val) return
      ;(this.dataForm.requisitionLines || []).forEach(line => { line.requiredDate = val })
    },
    sortRequisitionLines(lines) {
      return [...(lines || [])].sort((a, b) => {
        const sa = Number(a.lineSort) || 0
        const sb = Number(b.lineSort) || 0
        if (sa !== sb) return sa - sb
        return String(a.requisitionLineId || '').localeCompare(String(b.requisitionLineId || ''))
      })
    },
    nextLineSort() {
      let max = 0
      ;(this.dataForm.requisitionLines || []).forEach(l => {
        const s = Number(l.lineSort) || 0
        if (s > max) max = s
      })
      return max + 1
    },
    chooseMaterials(materials) {
      if (!materials || !materials.length) return
      const existing = new Set((this.dataForm.requisitionLines || []).map(l => l.materialId))
      let lineSort = this.nextLineSort()
      materials.forEach(m => {
        if (existing.has(m.materialId)) return
        this.dataForm.requisitionLines.push({
          requisitionLineId: '',
          materialId: m.materialId,
          materialCode: m.materialCode,
          materialName: m.materialName,
          specs: m.specs,
          quantity: 1,
          lineSort: lineSort++,
          requiredDate: this.defaultRequiredDate || '',
          remark: ''
        })
      })
    },
    removeLine(index) {
      this.dataForm.requisitionLines.splice(index, 1)
    },
    submitHandle() {
      if (!this.dataForm.requisitionId && !String(this.dataForm.deptName || '').trim()) {
        this.$message.error('当前登录用户未设置部门，请先在用户管理维护所属部门')
        return
      }
      if (!this.dataForm.requisitionLines.length) {
        this.$message.error('请至少维护一条请购明细')
        return
      }
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = {
          ...this.dataForm,
          requisitionLines: (this.dataForm.requisitionLines || []).map((line, index) => ({
            ...line,
            lineSort: index + 1,
            requiredDate: line.requiredDate ? String(line.requiredDate).slice(0, 10) : null
          })),
          lines: (this.dataForm.requisitionLines || []).map((line, index) => ({
            ...line,
            lineSort: index + 1,
            requiredDate: line.requiredDate ? String(line.requiredDate).slice(0, 10) : null
          }))
        }
        const url = '/purchase/purchaseRequisition/' + (this.dataForm.requisitionId ? 'update' : 'save')
        request.post(url, payload).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    },
    reload() {
      if (this.dataForm.requisitionId) this.init(this.dataForm.requisitionId, true)
    },
    runAction(api, successMsg, reloadOnSuccess) {
      this.approveDocActionLoading = true
      return api().then(() => {
        this.$message.success(successMsg)
        this.$emit('refreshDataList')
        if (reloadOnSuccess) this.reload()
      }).catch(() => {}).finally(() => { this.approveDocActionLoading = false })
    },
    approveFromView() {
      this.$confirm('审核后请购数量将被锁定，可转采购订单，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.runAction(
          () => request.post('/purchase/purchaseRequisition/approve', { requisitionId: this.dataForm.requisitionId }),
          '审核成功',
          true
        )
      }).catch(() => {})
    },
    unapproveFromView() {
      this.$confirm('弃审后需确保无转采购记录，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.runAction(
          () => request.post('/purchase/purchaseRequisition/unapprove', { requisitionId: this.dataForm.requisitionId }),
          '弃审成功',
          true
        )
      }).catch(() => {})
    },
    deleteFromView() {
      this.$confirm('确定删除该请购单?', '提示', { type: 'warning' }).then(() => {
        this.approveDocActionLoading = true
        request.post('/purchase/purchaseRequisition/delete', { requisitionId: this.dataForm.requisitionId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.approveDocActionLoading = false })
      }).catch(() => {})
    },
    submitForApprovalFromView() {
      const ui = this.workflowUi
      if (ui && ui.workflowEnabled && !ui.definitionMatched) {
        this.$alert(
          '尚未配置请购单审批流程，请先在「审批流程定义」中新增并启用请购单流程（至少一个审批步骤）后再提交。',
          '未配置审批流程',
          { type: 'warning', confirmButtonText: '我知道了' }
        )
        return
      }
      this.$confirm('提交后将进入审批流程，期间不可修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.runAction(
          () => request.post('/purchase/purchaseRequisition/submit', { requisitionId: this.dataForm.requisitionId }),
          '提交成功',
          true
        )
      }).catch(() => {})
    },
    wfApproveFromView() {
      const taskId = this.dataForm.myPendingTask && this.dataForm.myPendingTask.taskId
      if (!taskId) return
      this.$prompt('审批意见（可选）', '审批通过', { inputType: 'textarea', confirmButtonText: '通过' }).then(({ value }) => {
        this.runAction(
          () => request.post('/workflow/task/approve', { taskId, comment: value || '' }),
          '审批通过',
          true
        )
      }).catch(() => {})
    },
    wfRejectFromView() {
      const taskId = this.dataForm.myPendingTask && this.dataForm.myPendingTask.taskId
      if (!taskId) return
      this.$prompt('请输入驳回原因', '审批驳回', {
        inputType: 'textarea',
        confirmButtonText: '驳回',
        inputValidator: v => !!(v && String(v).trim()) || '驳回原因不能为空'
      }).then(({ value }) => {
        this.runAction(
          () => request.post('/workflow/task/reject', { taskId, comment: String(value).trim() }),
          '已驳回',
          true
        )
      }).catch(() => {})
    },
    convertPoFromView() {
      if (!this.dataForm.requisitionId) return
      this.$emit('convert-po', {
        requisitionId: this.dataForm.requisitionId,
        requisitionCode: this.dataForm.requisitionCode
      })
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; line-height: 32px; }
.doc-dialog-actions { display: flex; flex-direction: column; align-items: flex-end; }
.doc-dialog-actions >>> .el-button-group { display: flex; flex-wrap: wrap; }
.wf-hint { margin-top: 6px; color: #e6a23c; font-size: 12px; line-height: 1.4; }
</style>
